import React from "react";
import { useHistory } from "react-router-dom";
import { connect, useDispatch } from 'react-redux';
import { captureAdminRadioValue, captureUserRadioValue, captureSuperRadioValue, handleUserName, fullName } from 'pages/redux/actions';

import { Col,} from "reactstrap";

const Login = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    dispatch(handleUserName(''));
    dispatch(fullName(''));
    dispatch(captureSuperRadioValue(false))
    dispatch(captureAdminRadioValue(false))
    dispatch(captureUserRadioValue(false))
    history.push("/auth/login");
    // console.log(props.username)
    // console.log(props)
    return (
        <>
            <Col lg="5" md="7">
                <div className="btn-wrapper text-center">
                        <span className="btn-inner--text">Login</span>
                </div>
            </Col>
        </>
    );
};

// export default Login;

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
    }
}

export default connect(mapStateToProps)(Login);